import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Login from './views/Login.vue'
import Main from './views/Main.vue'
import NotFound from './views/NotFound.vue'
import { module$ } from './enums'
import { setDocumentTitle } from './locales'
import 'vue-router'

declare module 'vue-router' {
    interface RouteMeta {
        titleKey?: string
        hideTopBar?: boolean
        allowAnonymous?: boolean
        isHome?: boolean
    }
}

const routes: RouteRecordRaw[] = [
    {
        path: '/login',
        name: module$.login,
        component: Login,
        meta: { titleKey: 'login.title' }
    },
    {
        path: '/',
        name: module$.webPhone,
        component: () => import('./views/WebPhone.vue'),   // lazy → 獨立 chunk（WebPhone-[hash].js）
        meta: { titleKey: 'webrtcPhone.title', hideTopBar: true, allowAnonymous: true, isHome: true }
    },
    {
        // 巢狀路由的父層建議給予 path
        path: '/',
        component: Main,
        children: [
            {
                path: 'schedule',
                name: module$.scheduleMonitor,
                component: () => import('./views/ScheduleMonitor.vue'),
                meta: { titleKey: 'scheduleMonitor.title' }
            },
            {
                path: 'webrtc-stats',
                name: module$.webRtcStatsMonitor,
                component: () => import('./views/WebRtcStatsMonitor.vue'),
                meta: { titleKey: 'webRtcStatsMonitor.title' }
            }
        ]
    },
    { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound }
]

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes
})

router.afterEach((to) => {
    // 導航後設定標題(組字邏輯統一於 locales 的 setDocumentTitle,與元件切語系共用)
    setDocumentTitle(to.meta.titleKey as string | undefined)
})

export default router;